<script lang="ts">
    import { Col, Image } from "sveltestrap";
    import { Groups } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    import data from "../../../Data/ComponentData/Ui-kits/Avatars/Avatars.json"
    let imgPath : string = "/assets/images/user"
</script>

<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Groups} CardBodyprops="avatar-showcase">
        <div  slot="contentbody">
          {#each data.Groups as Imgdata}
              <div class="customers d-inline-block avatar-group">
                  <ul>
                    {#each Imgdata.ful as imgItem}
                      <li class="d-inline-block">
                        <Image class="{imgItem.class} rounded-circle" src="{imgPath}/{imgItem.src}" alt="" />
                      </li>
                    {/each}
                  </ul>
              </div>
          {/each}  
        </div>
    </Card>
</Col>



  
